import { useEffect, useState } from 'react';
import { useOptionalSession } from '../../app/providers/session-context';

const CHANGED = 'webtika:form-fields-changed';

export function notifyFormFieldsChanged(formKey) {
  window.dispatchEvent(new CustomEvent(CHANGED, { detail: { formKey } }));
}

export default function useFormTableFields(formKey, list) {
  const { currentUser } = useOptionalSession();
  const formKeys = Array.isArray(formKey) ? formKey : [formKey];
  const keysSignature = JSON.stringify(formKeys);
  const scope = `${currentUser?.tenantId || ''}:${currentUser?.id || ''}:${keysSignature}`;
  const [result, setResult] = useState({ scope, definitions: [], error: '' });
  useEffect(() => {
    let active = true;
    let revision = 0;
    if (!currentUser || !formKeys[0] || !list) return undefined;
    setResult({ scope, definitions: [], error: '' });
    const refresh = async () => {
      const request = ++revision;
      try {
        const definitions = (await Promise.all(formKeys.map((key) => list(key)))).flat();
        if (active && request === revision)
          setResult({ scope, definitions: Array.isArray(definitions) ? definitions : [], error: '' });
      } catch {
        if (active && request === revision)
          setResult((previous) => ({
            ...previous,
            error: 'Campi personalizzati non disponibili. Riprova aggiornando la pagina.',
          }));
      }
    };
    const changed = (event) => {
      if (formKeys.includes(event.detail?.formKey)) refresh();
    };
    refresh();
    window.addEventListener(CHANGED, changed);
    return () => {
      active = false;
      window.removeEventListener(CHANGED, changed);
    };
  }, [currentUser?.id, currentUser?.tenantId, keysSignature, list]);
  return result.scope === scope ? result : { definitions: [], error: '' };
}
